import oracleNetsuite from "src/assets/images/oracleNetsuite.png";
import FourRetail from "src/assets/logo/4Retail.svg";
import Adiquimica from "src/assets/logo/Adiquimica.png";
import Microsoft from "src/assets/logo/BusinessCentral.svg";
import Delsol from "src/assets/logo/Delsol.svg";
import Dropbox from "src/assets/logo/DropBox.svg";
import FTP from "src/assets/logo/ftp.png";
import GoogleDrive from "src/assets/logo/GoogleDrive.svg";
import Holded from "src/assets/logo/Holded.svg";
import MatiesAmer from "src/assets/logo/MatiesAmer.png";
import {
  default as Dost,
  default as DostLogo,
} from "src/assets/logo/newDostLogoWithoutText.png";
import Odoo from "src/assets/logo/Odoo.png";
import OneDrive from "src/assets/logo/OneDrive.svg";
import Quickbooks from "src/assets/logo/Quickbooks.svg";
import Sage from "src/assets/logo/Sage.svg";
import Sap from "src/assets/logo/Sap.svg";
import SapHana from "src/assets/logo/SapHana.svg";
import Xero from "src/assets/logo/xero.png";
import Abanca from "./Abanca.png";
import Barclays from "./barclays.png";
import BBVA from "./BBVA.png";
import CaixaBank from "./CaixaBank.jpg";
import csv from "./csv1.png";
import DevengoPaymentGateway from "./devengo.png";
import askDost from "./gradientsparkle.svg";
import Halifax from "./halifax.png";
import HSBC from "./hsbc.png";
import Ibercaja from "./Ibercaja.png";
import IngDirect from "./IngDirect.png";
import Kutxa from "./Kutxa.png";
import LloydsBank from "./lloyds.png";
import Monzo from "./monzo.png";
import NationwideBuildingSociety from "./nationwideBuildingSociety.png";
import NatWest from "./natwest.png";
import Openbank from "./OpenBank.png";
import PlaidPaymentGateway from "./plaid.svg";
import Revolut from "./Revolut.png";
import Sabadell from "./Sabadell.jpg";
import Santader from "./Santader.jpg";
import SEPA from "./sepa.png";
import Slack from "./Slack.png";
import Starling from "./starling.png";
import SwanPaymentGateway from "./swanPaymentGateway.svg";
import Unicaja from "./Unicaja.png";
import Wealthreader from "./wealthReader.png";
import WhatsApp from "./Whatsapp.png";
import Wise from "./Wise.png";
// Emojis
import absolutelyImg from "src/assets/logo/EmojiAbsolutely.png";
import likelyImg from "src/assets/logo/EmojiLikely.png";
import maybeImg from "src/assets/logo/EmojiMaybe.png";
import neverImg from "src/assets/logo/EmojiNever.png";
import unlikelyImg from "src/assets/logo/EmojiUnlikely.png";

const images = {
  neverImg,
  unlikelyImg,
  maybeImg,
  likelyImg,
  absolutelyImg,
  SwanPaymentGateway,
  PlaidPaymentGateway,
  DevengoPaymentGateway,
  Dost: DostLogo,
  csv,
  adiquimica_output_connector: Adiquimica,
  Holded,
  holded_output_connector: Holded,
  quickbook_output_connector: Quickbooks,
  onedrive_output_connector: OneDrive,
  SAPB1_output_connector: Sap,
  sapbone_output_connector: Sap,
  businesscentral_output_connector: Microsoft,
  businesscentral_onprem_output_connector: Microsoft,
  ftp_input_connector: FTP,
  ftp_upload_output_connector: FTP,
  onedrive_input_connector: OneDrive,
  delsol_output_connector: Delsol,
  ftp_output_connector: FTP,
  asap_output_connector: Dost,
  volotea_output_connector: Dost,
  googledrive_output_connector: GoogleDrive,
  googledrive_input_connector: GoogleDrive,
  netsuite_output_connector: oracleNetsuite,
  businesscentral_v2_output_connector: Microsoft,
  odoo_output_connector: Odoo,
  sagex3_output_connector: Sage,
  fourretail_output_connector: FourRetail,
  matiasamer_output_connector: MatiesAmer,
  sagardi_output_connector: Microsoft,
  delsol: Delsol,
  holded: Holded,
  quickbooks: Quickbooks,
  "sap b1": Sap,
  sap: Sap,
  webservice: Dost,
  sage: Sage,
  "Sage X3": Sage,
  "microsoft 365": Microsoft,
  saphana: SapHana,
  onedrive: OneDrive,
  dropbox: Dropbox,
  googledrive: GoogleDrive,
  ftp: FTP,
  "Banco Santander (ES)": Santader,
  "Banco Sabadell (ES)": Sabadell,
  "Revolut (ES)": Revolut,
  Swan: SwanPaymentGateway,
  BBVA,
  CaixaBank,
  "Wise (ES)": Wise,
  "ING Direct (ES)": IngDirect,
  "Kutxabank - Online Banking": Kutxa,
  "Unicaja Banco": Unicaja,
  Ibercaja,
  Abanca,
  Openbank,
  "BBVA - Banca Empresas": BBVA,
  "CaixaBank - Banca Empresas": CaixaBank,
  "BBVA - Banca Personal": BBVA,
  xero_output_connector: Xero,
  slack_notification_app: Slack,
  whatsapp_notification_app: WhatsApp,
  "Barclays (UK) - Online Banking: Personal": Barclays,
  "Barclays (UK) - Business": Barclays,
  "Barclays (UK) - Corporate": Barclays,
  "Barclays (UK) - Online Banking: Wealth Management": Barclays,
  "Lloyds Bank - Personal": LloydsBank,
  "Lloyds Bank - Business": LloydsBank,
  "Lloyds Bank - Commercial": LloydsBank,
  "HSBC (UK) - Personal": HSBC,
  "HSBC (UK) - Business": HSBC,
  "HSBC (UK) - Corporate: HSBCnet": HSBC,
  "HSBC (UK) - HSBC Kinetic": HSBC,
  "Monzo (UK)": Monzo,
  "NatWest - Personal": NatWest,
  "NatWest - Business": NatWest,
  Halifax,
  "Revolut (UK)": Revolut,
  Starling,
  "Nationwide Building Society": NationwideBuildingSociety,
  SEPA: SEPA,
  askDost,
  Wealthreader,
  WealthreaderPaymentGateway: Wealthreader,
};

export default images;
